<template>
	<configuration-editor configKey="interests" columnTitle="Interest" inputType="input"></configuration-editor>
</template>
<script>
import ConfigurationEditor from "./ConfigurationEditor";
export default {
	components: {
		ConfigurationEditor
	}
}
</script>


// WEBPACK FOOTER //
// src/components/ConfigurationInterests.vue